import {
  TextField as TextFieldUI,
  TextAreaField as TextAreaFieldUI,
  SelectField as SelectFieldUI,
  DateField as DateFieldUI,
  OTPField as OTPFieldUI,
  CheckboxField as CheckboxFieldUI,
  RadioButtonGroupField as RadioButtonGroupFieldUI,
  PhoneField as PhoneFieldUI,
  Editable,
  FileField as FileFieldUI,
  TextGroupField as TextGroupFieldUI,
} from 'ui';
import {
  connectControlField,
  connectPhoneField,
} from './connectFieldHOC';

export const OTPField = connectControlField(OTPFieldUI);
export const TextField = connectControlField(TextFieldUI);
export const TextGroupField = connectControlField(TextGroupFieldUI);
export const DateField = connectControlField(DateFieldUI);
export const PhoneField = connectPhoneField(PhoneFieldUI);
export const SelectField = connectControlField(SelectFieldUI);
export const RadioButtonGroupField = connectControlField(RadioButtonGroupFieldUI);
export const EditableField = connectControlField(Editable);
export const TextAreaField = connectControlField(TextAreaFieldUI, { noOfLines: 5 });
export const FileField = connectControlField(
  FileFieldUI,
  { defaultValue: '', isFile: true },
);
export const CheckboxField = connectControlField(
  CheckboxFieldUI,
  { defaultValue: false, isCheckbox: true },
);
